import { forwardRef, ForwardRefExoticComponent, ReactNode, Ref, RefAttributes } from 'react';

export const forwardRefWithGeneric = <TElement, TProps = object>(
  render: (props: TProps, ref: Ref<TElement>) => ReactNode,
): ((props: TProps & RefAttributes<TElement>) => ReactNode) => {
  return forwardRef(render) as ForwardRefExoticComponent<TProps>;
};
